import SeoHelmet from "@/components/SeoHelmet";
import Navbar from "@/components/Navbar";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] dark:bg-[#0A0F1E] text-slate-900 dark:text-white font-body">
      <SeoHelmet 
        title="About Us" 
        description="Learn about Alvaru's mission to help job seekers get more interviews with AI CV tailoring."
        canonical="https://www.alvaru.com/about"
      />
      <Navbar />
      <div className="container mx-auto px-6 py-24 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-heading font-bold mb-12 text-center">About Alvaru</h1>
        
        <div className="space-y-12">
          <section>
            <h2 className="text-2xl font-bold font-heading mb-4 text-cyan-600 dark:text-cyan-400">Our Mission</h2>
            <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
              At Alvaru, our mission is to level the playing field for job seekers by providing an intelligent, automated CV tailoring tool. We believe that a great candidate shouldn't be filtered out just because their resume doesn't perfectly match the arbitrary keywords of an Applicant Tracking System (ATS).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold font-heading mb-4 text-cyan-600 dark:text-cyan-400">How Alvaru Works</h2>
            <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300 mb-4">
              Alvaru acts as your personal AI CV optimizer that works directly in your browser. When you find a job you want to apply for, our Chrome Extension analyzes the job description to identify key skills, requirements, and industry terminology.
            </p>
            <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
              It then seamlessly adapts your master CV, highlighting your most relevant experience and matching the vocabulary of the job posting—all without inventing false history. Finally, it helps you auto-apply with a single click, saving you hours of manual rewriting.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold font-heading mb-4 text-cyan-600 dark:text-cyan-400">The Founder</h2>
            <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
              Alvaru was created by a developer who experienced firsthand the frustration of spending hours tailoring CVs only to be ignored by automated filters. Drawing from experience in software engineering and AI, Alvaru was built to give job seekers an unfair advantage in the modern hiring landscape.
            </p>
          </section>

          <section className="bg-slate-100 dark:bg-slate-900/50 p-8 rounded-2xl border border-slate-200 dark:border-slate-800 text-center">
            <h2 className="text-2xl font-bold font-heading mb-4">Get in Touch</h2>
            <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
              Have questions, feedback, or need support? We'd love to hear from you.
            </p>
            <p className="text-xl mt-6 font-bold text-cyan-600 dark:text-cyan-400">
              <a href="mailto:hello@alvaru.com" className="hover:underline">hello@alvaru.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
